/**
 * @generated SignedSource<<dfd8dc5eb7f253ee53d1bea957c6acc0>>
 * @relayHash 7ce716fdea722f967a9038e59ad7b8cc
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ce716fdea722f967a9038e59ad7b8cc

import { ConcreteRequest } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type findDePatientByInternalIdQuery$variables = {
  internalId: number;
};
export type findDePatientByInternalIdQuery$data = {
  readonly de_patientByInternalId: {
    readonly contactChannel: ContactChannel;
    readonly country: Country;
    readonly displayId: number;
    readonly duplicatePatients: ReadonlyArray<{
      readonly contactChannel: ContactChannel;
      readonly displayId: number;
      readonly firstName: string;
      readonly gender: Gender;
      readonly id: string;
      readonly lastName: string;
    }>;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  } | null;
};
export type findDePatientByInternalIdQuery = {
  response: findDePatientByInternalIdQuery$data;
  variables: findDePatientByInternalIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "internalId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannel",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientInternalId",
        "variableName": "internalId"
      }
    ],
    "concreteType": "de_Patient",
    "kind": "LinkedField",
    "name": "de_patientByInternalId",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DuplicatePatientOutput",
        "kind": "LinkedField",
        "name": "duplicatePatients",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "findDePatientByInternalIdQuery",
    "selections": (v7/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "findDePatientByInternalIdQuery",
    "selections": (v7/*:: as any*/)
  },
  "params": {
    "id": "7ce716fdea722f967a9038e59ad7b8cc",
    "metadata": {},
    "name": "findDePatientByInternalIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "25692c6dddf146d5380451ef4a8fbfef";

export default node;
